import { useRef, useState } from "react";
import { Aviso, Botao } from "../ui";
import { useExcluirImplantacao } from "../../nucleo/contatosDeAcesso";

export function ExcluirImplantacao({
  id,
  nome,
  podeExcluir,
  aoExcluir,
  aoCancelar,
}: {
  id: string;
  nome: string;
  podeExcluir: boolean;
  aoExcluir: (mensagem: string) => void;
  /* Aberta pelo menu Mais ações (SUS-15400): já nasce na confirmação, e "Manter implantação"
     devolve a quem abriu, que fecha o painel e cuida do foco. */
  aoCancelar?: () => void;
}) {
  const [confirmando, setConfirmando] = useState(aoCancelar !== undefined);
  const [concordou, setConcordou] = useState(false);
  const acao = useRef<HTMLButtonElement>(null);
  const excluir = useExcluirImplantacao(id);
  if (!podeExcluir) return null;
  return (
    <section className="mt-6 mb-6" aria-labelledby="titulo-excluir-implantacao">
      <h2 className="titulo-secao" id="titulo-excluir-implantacao">
        Excluir implantação
      </h2>
      {!confirmando ? (
        <Botao
          ref={acao}
          variante="fantasma"
          onClick={() => setConfirmando(true)}
        >
          Excluir implantação
        </Botao>
      ) : (
        <div>
          <Aviso tom="erro">
            Excluir a implantação de {nome}? Ela sairá do portal, os convites e
            acessos sem outra implantação serão revogados e as credenciais desta
            implantação serão descartadas. O histórico de auditoria será
            preservado. A sinalização no GEOtask depende de integração e
            precisará de acompanhamento pela equipe.
          </Aviso>
          <label className="flex items-center min-h-11 gap-2 mt-4">
            <input
              type="checkbox"
              checked={concordou}
              onChange={(e) => setConcordou(e.target.checked)}
            />
            Confirmo a exclusão da implantação de {nome}
          </label>
          {excluir.isError ? (
            <Aviso tom="erro">
              {excluir.error.message} Não foi possível confirmar a exclusão.
              Confira a carteira antes de tentar de novo.
            </Aviso>
          ) : null}
          <div className="flex gap-2 mt-4">
            <Botao
              autoFocus
              variante="fantasma"
              disabled={excluir.isPending}
              onClick={() => {
                if (aoCancelar) return aoCancelar();
                setConfirmando(false);
                setConcordou(false);
                setTimeout(() => acao.current?.focus(), 0);
              }}
            >
              Manter implantação
            </Botao>
            <Botao
              disabled={!concordou || excluir.isPending}
              onClick={() =>
                excluir.mutate(undefined, {
                  onSuccess: (resultado) => aoExcluir(resultado.mensagem),
                })
              }
            >
              {excluir.isPending ? "Excluindo…" : "Confirmar exclusão"}
            </Botao>
          </div>
        </div>
      )}
    </section>
  );
}
